import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { createThecnicalSupportRequestService } from "../services/technicalSupport.services";
import { ToastControlBackendModel } from "../../../components/Sidebar/ToastBackControl/models/toastBackControl.model";

interface Props {
  idUser: number;
  getAllTechnicalSupportByUser: () => void;
  setMessageBackend: (value: ToastControlBackendModel) => void;
}

const formStyles = `
  .custom-support-input .p-inputtext {
    width: 100% !important;
    padding: 14px 16px !important;
    border-radius: 12px !important;
    border: 1.5px solid #e2e8f0 !important;
    font-size: 0.9rem !important;
    color: #1e293b !important;
    background: #ffffff !important;
    box-shadow: none !important;
    transition: all 0.2s;
  }
  .custom-support-input .p-inputtext:focus {
    border-color: #00A86B !important;
    box-shadow: 0 0 0 3px rgba(0, 168, 107, 0.12) !important;
  }

  .custom-support-btn.p-button {
    background: #00A86B !important;
    border: none !important;
    border-radius: 12px !important;
    padding: 14px 28px !important;
    font-weight: 600 !important;
    font-size: 0.9rem !important;
    box-shadow: 0 4px 14px rgba(0, 168, 107, 0.25) !important;
    transition: all 0.2s !important;
    width: 100%;
  }
  .custom-support-btn.p-button:hover:not(:disabled) {
    background: #009960 !important;
    box-shadow: 0 6px 20px rgba(0, 168, 107, 0.35) !important;
  }
  .custom-support-btn.p-button:disabled {
    background: #cbd5e1 !important;
    color: #94a3b8 !important;
    box-shadow: none !important;
  }
`;

function FormTechnicalSupport({
  idUser,
  getAllTechnicalSupportByUser,
  setMessageBackend,
}: Props): JSX.Element {
  const [description, setDescription] = useState<string>("");
  const [loading, setLoading] = useState(true);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); 
    setLoading(true);
    try {
      const data = {
        idUser: Number(idUser),
        description: description,
      };
      const response = await createThecnicalSupportRequestService(data);
      if (response.statusCode < 299) {
        getAllTechnicalSupportByUser();
        setDescription("");
        setMessageBackend({
          severityValue: "success",
          detailValue: "Se ha enviado la consulta",
          lifeValue: 3000,
          validateShowMessage: true,
        });
      }
    } catch (error) {
      setMessageBackend({
        severityValue: "error",
        detailValue: "Error al enviar la consulta",
        lifeValue: 3000,
        validateShowMessage: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (description.trim().length > 2) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [description]);

  return (
    <>
      <style>{formStyles}</style>
      <form onSubmit={onSubmit} className="grid align-items-center custom-support-form">
        <div className="col-12 md:col-9 custom-support-input">
          <InputText
            type="text"
            value={description}
            placeholder="Escriba detalladamente su consulta aquí..."
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)}
          />
        </div>
        <div className="col-12 md:col-3">
          <Button
            className="custom-support-btn text-white"
            label="Enviar consulta"
            type="submit"
            icon="pi pi-send"
            disabled={loading}
          />
        </div>
      </form>
    </>
  );
}

export default FormTechnicalSupport;